<template>
  <div class="wrapper">
    <el-carousel v-if="advertList.length > 0">
      <el-carousel-item v-for="(item, index) in advertList" :key="index">
        <img :src="item.img" alt width="100%" @click="swiperClick(item)" />
      </el-carousel-item>
    </el-carousel>
    <div class="main">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="first"></el-tab-pane>
        <el-tab-pane label="阳光讲师专属" name="second"></el-tab-pane>
        <el-tab-pane label="限时抢兑" name="third"></el-tab-pane>
      </el-tabs>
      <div class="filterBox">
        <div>排序:</div>
        <div
          class="boderRi"
          :class="[ filterCurrent == 0 ? 'activeColor'  : '']"
          @click="fliterClick(0)"
        >综合</div>
        <div
          class="boderRi"
          :class="[ filterCurrent == 1 ? 'activeColor'  : '']"
          @click="fliterClick(1)"
        >
          积分
          <i class="el-icon-top" v-if="arrow1"></i>
          <i class="el-icon-bottom" v-else></i>
        </div>
        <div :class="[ filterCurrent == 2 ? 'activeColor'  : '']" @click="fliterClick(2)">
          销量
          <i class="el-icon-top" v-if="arrow2"></i>
          <i class="el-icon-bottom" v-else></i>
        </div>
      </div>
      <ul class="listBox" v-if="goodsList.length>0">
        <li @click="goDetail(item.id)" v-for="(item, index) in goodsList" :key="index">
          <div class="imgBox">
            <img :src="item.image_url" alt />
          </div>
          <div class="info">
            <p class="goodsName">{{ item.name }}</p>
            <div class="amountType" v-if="item.open_point == 1">现金+积分</div>
            <div class="amountType" v-if="item.open_point == 2">积分</div>
			 <div class="amountType" v-if="item.exclusive == 1">阳光讲师专属</div>
			
            <p class="amount" v-if="item.open_point == 1">
              {{ item.point }}
              <span>积分</span>
              <span>+¥{{ item.price }}</span>
            </p>
            <p class="amount" v-if="item.open_point == 2">
              {{ item.point }}
              <span>积分</span>
            </p>
			
			
          </div>
        </li>
      </ul>
      <template v-if="goodsList.length>0">
        <Pagination
          :totalPage="totalPage"
          :limit="searchOptions.limit"
          @changePage="handleCurrentChange"
        ></Pagination>
      </template>
    </div>
	<ScrollToTop></ScrollToTop>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";
import { deepCopy } from "@/utils";
import { goodsStyle } from "@/utils";
import { showLoading, hideLoading } from "../../utils/loading";
import ScrollToTop from "@/components/common/ScrollToTop.vue";
import { isSafeRedirect } from "@/utils";
export default {
  name: "list",
  components: { Pagination ,ScrollToTop},
  props: {},
  data() {
    return {
      filterCurrent: 0, //默认选中
      arrow1: true, //排序指向
      arrow2: true, //
      current: "0",
      activeName: "first",
      userInfo: {},
      advertList: [],
      goodsList: [],
      totalPage: 0,
      searchOptions: {
        where: {
          open_point: [1, 2]
        },
        limit: 16,
        page: 1,
        order: {
          key: "sort",
          sort: "asc" //默认综合排序
        }
      }
    };
  },
  watch: {
    $route(to, from) {
      console.log(from);
      if (from.name == "goodsDetail") return;
      if (this.$route.name == "list") {
        let query = this.$route.query;
        this.initData(query);
      }
    }
  },
  computed: {},

  methods: {
    fliterClick(idx) {
      console.log(idx);
      if (idx == 1) {
        this.arrow1 = !this.arrow1;
        if (!this.arrow1) {
          this.searchOptions.order = {
            key: "point",
            sort: "desc" //默认综合排序
          };
        } else {
          this.searchOptions.order = {
            key: "point",
            sort: "asc" //默认综合排序
          };
        }
      }
      if (idx == 2) {
        this.arrow2 = !this.arrow2;
        if (!this.arrow2) {
          this.searchOptions.order = {
            key: "buy_count",
            sort: "desc" //默认综合排序
          };
        } else {
          this.searchOptions.order = {
            key: "buy_count",
            sort: "asc" //默认综合排序
          };
        }
      }
      if (idx == 0) {
        this.searchOptions.order = {
          key: "sort",
          sort: "asc" //默认综合排序
        };
      }
      this.filterCurrent = idx;
      this.searchOptions.page = 1;
      let query = this.$route.query;
      this.handleParamsData(query);
    },
    initData(query) {
      let sd = this.searchOptions;
      this.searchOptions = Object.assign(sd, { where: {} });
      this.handleParamsData(query);
    },
    handleClick(tab, event) {
      if (tab.name == "first") {
        this.searchOptions.where.open_point = [1, 2];
        this.searchOptions.where.exclusive = "";
      } else if (tab.name == "second") {
        this.searchOptions.where.open_point = [1, 2];
        this.searchOptions.where.exclusive = 1;
      } else if (tab.name == "third") {
        this.searchOptions.where.open_point = [1, 2];
        this.searchOptions.where.exclusive = 2;
      }
      this.searchOptions.page = 1;
      let query = this.$route.query;
      this.handleParamsData(query);
    },
    goDetail(id) {
      console.log(id);
	  let { href } =  this.$router.resolve({
	     name: 'pointListGoodsDetail',
	     params: {id:id}
	   })
	  if (!isSafeRedirect(href)) {
	    console.warn('非白名单域名，禁止跳转:', href);
	    return;
	  }
	  window.open(href, '_blank')
	  return;
				
      this.$router.push({
        path: "/point/goodsDetail",
        query: {
          id
        }
      });
    },
    getUserInfo() {
      this.$api.userInfo().then(result => {
        if (result.status) {
          this.userInfo = result.data;
        }
      });
    },
    advert() {
      let _this = this;
      this.$api.advert({ codes: "pc_point_activity" }).then(res => {
        _this.advertList = res.data.list["pc_point_activity"] || [];
        console.log(_this.advertList);
        hideLoading();
      });
    },
    //筛选条件参数处理
    conditions() {
      let data = this.searchOptions;
      var newData = {};
      newData = deepCopy(newData, data);
      //把data里的where换成json
      if (data.where) {
        newData.where = JSON.stringify(data.where);
      }
      //把排序换成字符串
      if (data.order) {
        var sort = data.order.key + " " + data.order.sort;
        if (data.order.key != "sort") {
          sort = sort + ",sort asc"; //如果不是综合排序，增加上第二个排序优先级排序
        }
        newData.order = sort;
      } else {
        newData.order = "sort asc";
      }
      return newData;
    },
    handleParamsData(query) {
      let where = {};
      if (query.key) {
        where = { search_name: query.key };
      }
      if (query.id) {
        where = {
          cat_id: query.id
        };
      }
      if (query.type) {
        if (query.type == "hot") {
          where = {
            hot: true
          };
        }
        if (query.type == "recommend") {
          where = {
            recommend: true
          };
        }
      }
      this.setSearchOptions({ where: where });
      this.getGoodsList();
    },
    //获取商品列表
    getGoodsList() {
      let obj = this.conditions();
      this.loadingShow = true;
      this.$api.goodsList(obj).then(res => {
        if (res.status) {
          this.totalPage = res.data.total_page;
          this.goodsList = res.data.list;
          console.log(this.goodsList);
          if (res.data.list.length == 0) {
            this.noDataIsShow = true;
          } else {
            this.noDataIsShow = false;
          }
          this.loadingShow = false;
        }
        hideLoading();
      });
    },
    //点击
    swiperClick(v) {
      // type 1 url 直接跳转
      // 2 商品
      //  3 文章
      // 4  文章分类
      // 5 智能表单
      // window.open('https://www.baidu.com','_blank')
		this.$api.addRecord({
			'type': '5',
			'api_method': "advert.getcarousellists",
			"platform": "1",
			"code": v.code,
			"rel_id": v.id
		})
      if (v.type == 1 && v.val!='#') {
        if (isSafeRedirect(v.val)) {
          window.open(v.val, "_blank");
        }
        return;
      }

      if (v.type == 2) {
        this.$router.push({
          path: `detail/${v.id}`
        });
        return;
      }
    },
    //设置筛选条件
    setSearchOptions: function(searchData, clear = false) {
      var sd = this.searchOptions;
      this.searchOptions = deepCopy(sd, searchData);
      if (clear) {
        this.goodsList = [];
      }
    },
    //分页
    handleCurrentChange(val) {
      this.setSearchOptions({
        page: val
      });
      this.getGoodsList();
    }
  },
  created() {
    showLoading();
    let query = this.$route.query;
    this.handleParamsData(query);
    this.advert();
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
// 排序盒子
.filterBox {
  height: 40px;
  display: flex;
  > div {
    width: 70px;
    height: 18px;
    text-align: center;
    line-height: 18px;
    font-size: 14px;
    cursor: pointer;
  }
  > div:first-child {
    text-align: start;
    width: 50px;
  }
  .boderRi {
    border-right: 1px solid #524d4d;
  }
  .activeColor {
    color: #fe4706;
  }
}
.main {
  width: 1252px;
  margin: 0 auto 50px;
}
.listBox {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  cursor: pointer;
  // justify-content: space-between;
  > li {
    width: 292px;
    margin: 0 10px 10px;
    .imgBox {
      width: 292px;
      height: 292px;
      overflow: hidden;
      > img {
        width: 100%;
        border-radius: 10px 10px 0 0;
      }
    }
  }
  .info {
    background-color: #fff;
    padding: 18px;
  }
  .goodsName {
    color: #1a1a1a;
    height: 48px;
    overflow: hidden;
    text-overflow: ellipsis; //当对象内文本溢出时显示省略标记
    display: -webkit-box;
    -webkit-line-clamp: 2; //这边的2指的是两行
    -webkit-box-orient: vertical;
    font-size: 16px;
    line-height: 24px;
  }
  .amountType {
    display: inline-block;
    border-radius: 4px;
    margin: 18px 4px 24px 0;
    border: 1px solid #fec200;
    color: #fec200;
    padding: 8px;
  }
  .amount {
    color: #fe4706;
  }
}
.pagination {
  margin: 30px auto;
  text-align: center;
}
</style>
